export enum ValidationActionType {
    WithdrawalTimeout = 'WITHDRAWAL_TIMEOUT',
    PledgeCollateralTimeout = 'PLEDGE_COLLATERAL_TIMEOUT',
    SendTimeout = 'SEND_TIMEOUT',
    OrderTimeout = 'ORDER_TIMEOUT'
}

export interface ValidationAction {
    type: ValidationActionType;
    payload?: any;
}

export const withdrawalTimeoutAction: ValidationAction = { type: ValidationActionType.WithdrawalTimeout };
export const pledgeCollateralTimeoutAction: ValidationAction = { type: ValidationActionType.PledgeCollateralTimeout };
export const sendTimeoutAction: ValidationAction = { type: ValidationActionType.SendTimeout };
export const orderTimeoutAction: ValidationAction = { type: ValidationActionType.OrderTimeout };